import { render, staticRenderFns } from "./GaugeChart.vue?vue&type=template&id=2d863f4f&scoped=true"
import script from "./GaugeChart.vue?vue&type=script&lang=js"
export * from "./GaugeChart.vue?vue&type=script&lang=js"
import style0 from "./GaugeChart.vue?vue&type=style&index=0&id=2d863f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d863f4f",
  null
  
)

export default component.exports